export enum LocationOptions {
  currentLocation = 'Current Location',
  byAddress = 'Address',
}

export const EdmontonCoordinates = {
  lat: 53.5395,
  lng: -113.515,
};
